module.exports = __webpack_public_path__ + "img/types+categories.e9196c75.jpg";